import { useEffect } from "react";
import { useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigation/types";
import { useAuth0 } from "../../hooks/Login/useAuth0";


export const TokenWatcher = () => {
  const { isTokenExpired, logoutFromAuth0 } = useAuth0();
  
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>();

  useEffect(() => {
    const interval = setInterval(async () => {
      const expired = await isTokenExpired();
      if (expired) {
        console.log("⛔ Token expirado, cerrando sesión...");
        await logoutFromAuth0();
        navigation.reset({
          index: 0,
          routes: [{ name: "Landing" }],
        });
      }
    }, 60000); // cada minuto

    return () => clearInterval(interval);
  }, []);

  return null; 
};